import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || '/api';

const getAuthHeaders = () => {
    const token = localStorage.getItem('token');
    return {
        headers: { Authorization: `Bearer ${token}` }
    };
};

const ObtenerAsesorActualDesdeStorage = () => {
    try {
        const UsuarioSerializado = localStorage.getItem('usuario');
        if (!UsuarioSerializado) {
            return null;
        }

        const UsuarioActual = JSON.parse(UsuarioSerializado);
        if (!UsuarioActual?.id) {
            return null;
        }

        return {
            id: UsuarioActual.id,
            nombre: UsuarioActual.nombre || UsuarioActual.name || 'Asesor actual',
            apellido: UsuarioActual.apellido || '',
            email: UsuarioActual.email || '',
            telefono: UsuarioActual.telefono || '',
            estado: 'activo',
            rol: UsuarioActual.rol || 'vendedor'
        };
    } catch (ErrorActual) {
        console.error('Error leyendo asesor actual desde storage:', ErrorActual);
        return null;
    }
};

export const vendedorService = {
    // === VENDEDORES CRUD ===

    getVendedores: async () => {
        try {
            const response = await axios.get(`${API_URL}/auth/vendedores`, getAuthHeaders());
            return response.data;
        } catch (error) {
            console.error('Error fetching vendedores:', error);
            throw error;
        }
    },

    getAsesoresParaImportacion: async () => {
        try {
            const response = await axios.get(`${API_URL}/auth/vendedores`, getAuthHeaders());
            return response.data?.data || [];
        } catch (error) {
            const AsesorActual = ObtenerAsesorActualDesdeStorage();
            if (AsesorActual) {
                return [AsesorActual];
            }

            console.error('Error fetching asesores para importación:', error);
            throw error;
        }
    },

    createVendedor: async (vendedorData) => {
        try {
            const response = await axios.post(`${API_URL}/auth/vendedores`, vendedorData, getAuthHeaders());
            return response.data;
        } catch (error) {
            console.error('Error creating vendedor:', error);
            throw error;
        }
    },

    updateVendedor: async (id, vendedorData) => {
        try {
            const response = await axios.put(`${API_URL}/auth/vendedores/${id}`, vendedorData, getAuthHeaders());
            return response.data;
        } catch (error) {
            console.error('Error updating vendedor:', error);
            throw error;
        }
    },

    // === PROYECTOS DEL VENDEDOR ===

    getProyectosEmpresa: async () => {
        try {
            const response = await axios.get(`${API_URL}/proyecto/empresa`, getAuthHeaders());
            return response.data;
        } catch (error) {
            console.error('Error fetching proyectos:', error);
            throw error;
        }
    },

    getProyectosPorVendedor: async (idVendedor) => {
        try {
            const response = await axios.get(`${API_URL}/proyecto/vendedor/${idVendedor}/proyectos`, getAuthHeaders());
            return response.data;
        } catch (error) {
            console.error('Error fetching proyectos del vendedor:', error);
            throw error;
        }
    },

    getVendedoresPorProyecto: async (proyectoId) => {
        try {
            const response = await axios.get(`${API_URL}/proyecto/${proyectoId}/vendedores`, getAuthHeaders());
            return response.data;
        } catch (error) {
            console.error('Error fetching vendedores del proyecto:', error);
            throw error;
        }
    },

    asignarVendedorProyecto: async (proyectoId, idVendedor) => {
        try {
            const response = await axios.post(`${API_URL}/proyecto/${proyectoId}/vendedores`, { idVendedor }, getAuthHeaders());
            return response.data;
        } catch (error) {
            console.error('Error assigning proyecto:', error);
            throw error;
        }
    },

    desasignarVendedorProyecto: async (proyectoId, idVendedor) => {
        try {
            const response = await axios.delete(`${API_URL}/proyecto/${proyectoId}/vendedores/${idVendedor}`, getAuthHeaders());
            return response.data;
        } catch (error) {
            console.error('Error unassigning proyecto:', error);
            throw error;
        }
    }
};
